<template>
  <div>
    <div
      style="height:200px"
      v-for="(tick, idx) in Array.from(Array(element.number).keys())"
    ></div>
  </div>
</template>

<script>
// import Component from "../component_location"

export default {
  components: {},

  props: ["element"],

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
